import { useState, useEffect } from 'react';
import { ShieldCheck } from 'lucide-react';

function getRandomViewers() {
  return Math.floor(Math.random() * 12) + 6;
}

export function SocialProofBar() {
  const [viewers, setViewers] = useState(getRandomViewers);

  useEffect(() => {
    const interval = setInterval(() => {
      setViewers((prev) => {
        const delta = Math.random() > 0.5 ? 1 : -1;
        return Math.max(4, Math.min(20, prev + delta));
      });
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col xs:flex-row items-center justify-center gap-1.5 xs:gap-4 mb-3 sm:mb-4" data-testid="social-proof-bar">
      <span className="inline-flex items-center gap-1.5 text-[10px] xs:text-[11px] text-warm-500">
        <span className="inline-flex rounded-full h-1.5 w-1.5 bg-green-500"></span>
        {viewers} people checking eligibility now
      </span>
      <span className="inline-flex items-center gap-1 text-[10px] xs:text-[11px] text-warm-400">
        <ShieldCheck className="w-3 h-3 text-warm-400" />
        Secure &amp; encrypted
      </span>
    </div>
  );
}

export function SocialProofStrip() {
  return (
    <section className="py-5 sm:py-6 bg-white border-y border-warm-100" data-testid="social-proof-strip">
      <div className="container mx-auto px-4 max-w-3xl text-center">
        <p className="text-xs sm:text-sm text-warm-600">
          Trusted by <strong className="text-warm-800">over 10,000 Canadians</strong> across all provinces
        </p>
      </div>
    </section>
  );
}
